import React, { ChangeEvent, useState } from 'react';
import { HiProConsentGroup } from 'app/shared/interfaces/HiProApplicationResponse.interface';
import { HiProConsent } from 'app/shared/enums';
import classNames from 'clsx';

import { ConsentField } from '../ConsentField';
import { useStyles } from './GroupConsent.styles';

export default function GroupConsent({
  group,
  handleChangeGroupConsents,
  handleUnCheckedGroup,
}: {
  group: HiProConsentGroup;
  handleChangeGroupConsents: (
    value: ChangeEvent<HTMLInputElement>,
    code: string
  ) => void;
  handleUnCheckedGroup: (
    value: ChangeEvent<HTMLInputElement>,
    codeGroup: string,
    codeConsent: string
  ) => void;
}) {
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <>
      <ConsentField
        key={group.code}
        consent={group}
        onChange={(value) => handleChangeGroupConsents(value, group.code)}
        showAllLabel
      />
      <span
        tabIndex={0}
        className={classNames(classes.expandBtn, 'focusVisibleOutline')}
        onClick={() => setIsExpanded(!isExpanded)}
        onKeyDown={(e) => {
          if (
            e.target === e.currentTarget &&
            (e.key === 'Enter' || e.key === ' ')
          ) {
            e.preventDefault();
            setIsExpanded(!isExpanded);
          }
        }}
      >
        {isExpanded
          ? HiProConsent.Collapse
          : HiProConsent.TextToExpandSubConsents}
      </span>
      {isExpanded && (
        <div className={classes.consentGroup}>
          {group.groupConsents?.map((consent) => (
            <div className={classes.consent} key={consent.code}>
              <ConsentField
                consent={consent}
                onChange={(value) =>
                  handleUnCheckedGroup(value, group.code, consent.code)
                }
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
}
